import { View, Text, Image } from "@react-pdf/renderer";
import styles from "../../css";

import GradeBar from "../../images/gradesBar.png";

export const ReportNewDetails = ({ profile, ksa }) => {
  return (
    <View style={styles.report_container}>
      <View style={{ textAlign: "center" }}>
        <Text style={styles.heading}>
          Abu Dhabi Government Cybersecurity Building Capability
        </Text>
        <Text style={styles.subHeading}>Skills Gap Assessment Report</Text>
      </View>
      <View style={styles.big_header}>
        <Text>Employee Details</Text>
      </View>
      <View style={styles.employee_details}>
        <View style={styles.employee_table_left}>
          <Text style={{ fontFamily: "CircularStd", fontWeight: "bold" }}>
            Name:{" "}
            <Text style={{ fontWeight: "normal" }}>
              {profile["employee"]["name"]}
            </Text>
          </Text>
          <Text style={{ fontFamily: "CircularStd", fontWeight: "bold" }}>
            Current Job Title:{" "}
            <Text style={{ fontWeight: "normal" }}>
              {profile["employee"]["job title"]}
            </Text>
          </Text>
          <Text style={{ fontFamily: "CircularStd", fontWeight: "bold" }}>
            Email:{" "}
            <Text style={{ fontWeight: "normal" }}>
              {profile["employee"]["email"]}
            </Text>{" "}
          </Text>
          <Text style={{ fontFamily: "CircularStd", fontWeight: "bold" }}>
            Reporting To:{" "}
            <Text style={{ fontWeight: "normal" }}>
              {profile["employee"]["role reporting to"]}
            </Text>
          </Text>
        </View>
        <View style={styles.employee_table_right}>
          <Text style={{ fontFamily: "CircularStd", fontWeight: "bold" }}>
            Entity:{" "}
            <Text style={{ fontWeight: "normal" }}>
              {profile["employee"]["entity"]}
            </Text>
          </Text>
          <Text style={{ fontFamily: "CircularStd", fontWeight: "bold" }}>
            Experience:{" "}
            <Text style={{ fontWeight: "normal" }}>
              {profile["employee"]["years of experience"]}
            </Text>
          </Text>
          <Text style={{ fontFamily: "CircularStd", fontWeight: "bold" }}>
            Nationality:{" "}
            <Text style={{ fontWeight: "normal" }}>
              {profile["employee"]["nationality"]}
            </Text>
          </Text>
          <Text style={{ fontFamily: "CircularStd", fontWeight: "bold" }}>
            Reporting To You:{" "}
            <Text style={{ fontWeight: "normal" }}>
              {profile["employee"]["reporting to you"]}
            </Text>
          </Text>
        </View>
      </View>
      <View style={styles.big_header}>
        <Text>Cybersecurity Competencies Level</Text>
      </View>
      <View style={styles.competency_table}>
        <Text style={styles.text_description}>
          This section illustrates the cybersecurity competencies level that
          have been assessed. Each box represents one competency and the needed
          areas of improvements in Knowledge, Skills or Abilities.
        </Text>
        <Image style={styles.grade_bar} src={GradeBar} />

        <View style={styles.comp_container_row}>
          {ksa &&
            ksa.map((ksa, index) => {
              return (
                <View key={index} style={styles.comp_table_long} wrap={false}>
                  <View style={styles.comp_table_divider}>
                    <View
                      style={{
                        ...styles.comp_table_divider_line,
                        backgroundColor: ksa["color"],
                      }}
                    />
                    <Image
                      style={styles.comp_table_grade_image}
                      src={require(`../../images/grade-${ksa["grade"]}.png`)}
                    />
                  </View>
                  <Text style={styles.comp_table_header} wrap={false}>
                    {ksa["title"]}
                  </Text>
                  <Text style={styles.comp_table_text} wrap={false}>
                    {ksa["description"]}
                  </Text>
                </View>
              );
            })}
        </View>
      </View>
    </View>
  );
};

const Report = ({ userProfile, ksa }) => {
  return (
    <View>
      <ReportNewDetails profile={userProfile} ksa={ksa} />
    </View>
  );
};

export default Report;
